import TextField from '@material-ui/core/TextField';
import {withStyles} from '@material-ui/core/styles/index';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import React, {PureComponent} from 'react';
import {loginWithCredentials, loginWithToken} from "../../api";
import Loader from "../Simple/Loader";

const styles = theme => ({
    card: {
        margin: theme.spacing(1),
        maxWidth: 400,
        padding: theme.spacing(1),
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        width: '100%',
    },
    dense: {
        marginTop: 16,
    },
    menu: {
        width: 200,
    },
    button: {
        margin: theme.spacing(1),
    },
    imageWrapper: {
        textAlign: 'center',
        padding: theme.spacing(6),
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    image: {
        maxWidth: '100%',
    },
    loadingSpinner: {
        color: theme.palette.primary[500],
        marginRight: theme.spacing(1),
        marginBottom: -theme.spacing(1)
    },
    message: {
        color: 'green',
        marginBottom: -20,
    },
    description: {
        marginBottom: theme.spacing(2),
    },
    errorMessage: {
        color: 'red',
        marginBottom: -20,
    }
});

class SendPassword extends PureComponent {

    render() {
        const {classes, ssn, sentPassword, handleChange, postSendPassword, sendPasswordMessage, changeLoginType, sentPasswordErrorMessage, passwordSendLoading, passwordSentSuccessful, postSentPasswordLogin} = this.props

        return (
            <>
                {!passwordSentSuccessful && <><CardContent>
                    <Typography gutterBottom variant="body1" align="center" className={classes.description}>
                        Syötä henkilötunnuksesi. Lähetämme kertakäyttöisen salasanan sähköpostiisi. Salasana on voimassa
                        tunnin ajan.
                    </Typography>
                    <TextField
                        id="outlined-name"
                        label="Henkilötunnus"
                        className={classes.textField}
                        value={ssn}
                        name={'ssn'}
                        onChange={handleChange('ssn')}
                        margin="normal"
                        variant="outlined"
                    />
                    {sendPasswordMessage &&
                    <Typography gutterBottom variant="body1" align="center" className={classes.errorMessage}>
                        {sendPasswordMessage}
                    </Typography>}
                </CardContent>
                    <CardActions>
                        <Grid
                            justify="space-between"
                            container
                            spacing={1}
                        >
                            <Grid item>
                                <Button color="primary" className={classes.button}
                                        onClick={() => changeLoginType(null)}>
                                    Takaisin
                                </Button>
                            </Grid>
                            <Grid item>
                                {passwordSendLoading && <FontAwesomeIcon size='2x' icon={['fal', 'spinner-third']} spin
                                                                         className={classes.loadingSpinner}/>}


                                <Button variant="contained" color="primary" className={classes.button} disabled={passwordSendLoading}
                                        onClick={postSendPassword}>
                                    Lähetä salasana
                                </Button>
                            </Grid>
                        </Grid>
                    </CardActions>
                </>}
                {passwordSentSuccessful && <><CardContent>
                    <Typography gutterBottom variant="body1" align="center" className={classes.description}>
                        Lähetimme kertakäyttöisen salasanan sähköpostiisi. Salasana on voimassa
                        tunnin ajan. Kirjoita salasana alle.
                    </Typography>
                    <TextField
                        id="outlined-name"
                        label="Salasana"
                        className={classes.textField}
                        value={sentPassword}
                        name={'sentPassword'}
                        onChange={handleChange('sentPassword')}
                        margin="normal"
                        variant="outlined"
                    />
                    {sentPasswordErrorMessage &&
                    <Typography gutterBottom variant="body1" align="center" className={classes.errorMessage}>
                        {sentPasswordErrorMessage}
                    </Typography>}
                </CardContent>
                    <CardActions>
                        <Grid
                            justify="space-between"
                            container
                            spacing={1}
                        >
                            <Grid item>
                                <Button color="primary" className={classes.button}
                                        onClick={() => changeLoginType(null)}>
                                    Takaisin
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" className={classes.button}
                                        onClick={postSentPasswordLogin}>
                                    Kirjaudu
                                </Button>
                            </Grid>
                        </Grid>
                    </CardActions>
                </>}
            </>
        )
    };
}

export default withStyles(styles)(SendPassword);
